import * as React from 'react';

type ButtonProps = {
  'aria-owns': string | undefined;
  'aria-haspopup': 'true';
  onClick: (event: React.MouseEvent<HTMLElement>) => void;
};

type MenuProps = {
  id: string;
  anchorEl: State['anchorEl'];
  open: boolean;
  onClose: () => void;
};

type Props = {
  id: string;
  render: (props: { buttonProps: ButtonProps; menuProps: MenuProps }) => JSX.Element;
};

type State = {
  anchorEl: HTMLElement | null;
};

export class Popover extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      anchorEl: null
    };
  }

  handleClick = ({ currentTarget }: React.MouseEvent<HTMLElement>) => {
    this.setState({ anchorEl: currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  render() {
    const { id, render } = this.props;
    const { anchorEl } = this.state;

    return render({
      buttonProps: {
        'aria-owns': anchorEl ? id : undefined,
        'aria-haspopup': 'true',
        onClick: this.handleClick
      },
      menuProps: {
        id,
        anchorEl,
        open: Boolean(anchorEl),
        onClose: this.handleClose
      }
    });
  }
}
